import { ordinalize } from 'lodash-inflection';
import TeamStatsToDisplay from '~/constants/TeamStatsToDisplay';

const formatStatDisplay = (teamSplit, type) => stat => {
  /*  workaround for football since offensive and defensive comp use the same keys
      add a prefix to the stats in TeamStatsToDisplay and then remove it here to get the data
      add it back on to the normalized value so that team stats will render correct stats.
  */
  const key = type
    ? stat.key
        .split('_')
        .slice(1)
        .join('_')
    : stat.key;

  const rank = teamSplit[`${key}_rank`];
  const value = teamSplit[key];
  return {
    name: stat.key,
    rank,
    value,
  };
};

const normalizeFootballScoringSummary = event => {
  const teamsByApiUri = {};
  teamsByApiUri[event.away_team.api_uri] = event.away_team;
  teamsByApiUri[event.home_team.api_uri] = event.home_team;

  return event.box_score.scoring_summary.map(scoring => {
    const scoringPlay = scoring;

    if (scoring.scorer && scoring.scorer.full_name) {
      scoringPlay.player = scoring.scorer;
    } else {
      scoringPlay.player = {};
    }

    scoringPlay.segment_string = `${ordinalize(scoring.segment)} quarter`;
    scoringPlay.team = teamsByApiUri[scoring.team];
    scoringPlay.player.teams = [scoringPlay.team];

    scoringPlay.description = scoring.summary_text;
    return scoringPlay;
  });
};

const normalizeFootballEvent = event => {
  const comparisonExists = type => {
    const comparison = event[`${type}_comparison`];
    return comparison && comparison.home && comparison.away;
  };

  const newEvent = { ...event };
  if (event.box_score && event.box_score.scoring_summary.length) {
    newEvent.scoring_plays = normalizeFootballScoringSummary(event);
  }

  newEvent.home_stats_groups = [];
  newEvent.away_stats_groups = [];

  if (comparisonExists('offensive')) {
    const homeOffensiveComparison = event.offensive_comparison.home;
    const awayOffensiveComparison = event.offensive_comparison.away;

    newEvent.home_stats_groups.push({
      name: 'Offensive Stats',
      stats: TeamStatsToDisplay.nfl_pregame_offensive.map(
        formatStatDisplay(homeOffensiveComparison)
      ),
    });

    newEvent.away_stats_groups.push({
      name: 'Offensive Stats',
      stats: TeamStatsToDisplay.nfl_pregame_offensive.map(
        formatStatDisplay(awayOffensiveComparison)
      ),
    });
  }

  if (comparisonExists('defensive')) {
    const homeDefensiveComparison = event.defensive_comparison.home;
    const awayDefensiveComparison = event.defensive_comparison.away;

    newEvent.home_stats_groups.push({
      name: 'Defensive Stats',
      stats: TeamStatsToDisplay.nfl_pregame_defensive.map(
        formatStatDisplay(homeDefensiveComparison, 'defensive')
      ),
    });

    newEvent.away_stats_groups.push({
      name: 'Defensive Stats',
      stats: TeamStatsToDisplay.nfl_pregame_defensive.map(
        formatStatDisplay(awayDefensiveComparison, 'defensive')
      ),
    });
  }

  return newEvent;
};

export default normalizeFootballEvent;
